import { string } from 'yup';

export const urlValidation = string().nullable().required('Please enter a URL').url();
